import React from "react"
import {IonButton, IonIcon} from "@ionic/react";
import {useTranslation} from "react-i18next";
import {chevronForwardOutline, chevronForwardSharp} from "ionicons/icons";

interface buttonProps {
    disabled?: boolean
}

const FormButtonSaveChanges: React.FC<buttonProps> = ({disabled}) => {
    const { t } = useTranslation()

    disabled ??= false

    return (
        <IonButton color="bc-yellow" disabled={disabled} fill="solid" type="submit">
            {t('common.save_changes')}
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} slot="end"/>
        </IonButton>
    )
}

export default FormButtonSaveChanges
